import { CheckCircle } from 'assets/icons/CheckCircle';
import { useState, useEffect, useRef } from 'react';
import { FLOOR_PLANS_LAYOUT } from '../constants';
import SvgData from 'assets/json/mapfloors.json';
import { APARTMENT_ADAPTER } from 'consts';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

// const adapter = {
//   'vic-1.1': 'vic-1',
//   'vic-1.2': 'vic-2',
//   'vic-1.3': 'vic-3',
//   'vic-2.1': 'vic-1',
//   'vic-2.2': 'vic-2',
//   'vic-2.3': 'vic-3',
// };

export const FloorPlan = ({
  onShow,
  selectedBuilding,
  selectedFloor,
  clickedApartment,
  setClickedApartment,
  isViewingApartmentInfo,
}) => {
  const image = FLOOR_PLANS_LAYOUT[selectedBuilding].floors[selectedFloor];
  const { mapFloors: apartments, apartmentTemplates: templates } = SvgData;

  const [hoveredData, setHoveredData] = useState({
    position: null,
    data: null,
    isOpen: false,
  });
  const [isFading, setIsFading] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1025);
  const wasViewingApartmentRef = useRef(false);
  const clickedTimeoutRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const isDesktopWidth = window.innerWidth >= 1025;
      setIsDesktop(isDesktopWidth);

      if (!isDesktopWidth && hoveredData.isOpen) {
        setHoveredData({ position: null, data: null, isOpen: false });
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [hoveredData.isOpen]);

  const handleMouseEnter = (event, templateId) => {
    console.log('handleMouseEnter', { templateId });
    if (!isDesktop) return;

    const target = event.currentTarget;
    const rect = target.getBoundingClientRect();
    const data = templates[templateId];

    setHoveredData({
      position: {
        x: rect.left + rect.width + 16,
        y: rect.top,
      },
      data,
      isOpen: true,
    });
  };

  const handleMouseLeave = () => {
    if (!isDesktop) return;
    setHoveredData({ position: null, data: null, isOpen: false });
  };

  const onPathClick = (id) => {
    onShow(templates[id]);
  };

  // Trigger fade animation when user comes back from apartment info
  useEffect(() => {
    // If user was viewing apartment info and now is not, start fade animation
    if (
      wasViewingApartmentRef.current &&
      !isViewingApartmentInfo &&
      clickedApartment
    ) {
      setIsFading(true);

      // Auto-clear after 2 seconds
      if (clickedTimeoutRef.current) {
        clearTimeout(clickedTimeoutRef.current);
      }
      clickedTimeoutRef.current = setTimeout(() => {
        setClickedApartment(null);
        setIsFading(false);
      }, 2500);
    }

    // Track the previous state
    wasViewingApartmentRef.current = isViewingApartmentInfo;

    // Reset when clicked apartment is cleared
    if (!clickedApartment) {
      setIsFading(false);
    }
  }, [isViewingApartmentInfo, clickedApartment, setClickedApartment]);

  return (
    <>
      <div className="floor-plan-layout">
        <div className="layout-title">
          <p>
            <span>Mặt bằng căn hộ điển hình</span>
            <br />
            <span className="bold">
              Victory Heights | VIC{' '}
              <span className="number">
                {selectedBuilding === 'vic-1' ? '-1' : '-2'}
              </span>
            </span>
          </p>
        </div>
        <TransformWrapper centerZoomedOut disablePadding wheel={{ step: 0.02 }}>
          <TransformComponent>
            <div className={`floor-plan-container`}>
              <img
                src={image}
                alt={`Bản vẽ mặt bằng của ${selectedBuilding}-${selectedFloor}`}
              />
              <svg
                viewBox={
                  selectedBuilding === 'vic-1' ? '0 0 1238 573' : '0 0 1237 595'
                }
              >
                {Object.entries(apartments).map(([templateId, building]) => {
                  const mapPath = building[selectedBuilding];
                  const apartmentData = templates[templateId];

                  const { floor } = apartmentData;

                  if (floor !== selectedFloor) return null;
                  return (
                    <g key={templateId} className="path-group">
                      {mapPath.map((pathData, index) => {
                        const isClicked =
                          clickedApartment &&
                          clickedApartment.templateId === templateId &&
                          clickedApartment.pathData === pathData;

                        return (
                          <path
                            key={`${templateId}-path-${index}`}
                            id={`${templateId}-path-${pathData}`}
                            d={pathData}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className={`${
                              isClicked
                                ? isFading
                                  ? 'clicked-fading'
                                  : isDesktop
                                  ? 'clicked'
                                  : ''
                                : ''
                            }`}
                            strokeWidth="0.5"
                            stroke="#000"
                            onMouseEnter={(e) =>
                              handleMouseEnter(e, templateId)
                            }
                            onMouseLeave={handleMouseLeave}
                            onClick={() => {
                              if (clickedTimeoutRef.current) {
                                clearTimeout(clickedTimeoutRef.current);
                              }
                              setIsFading(false);
                              setClickedApartment({ templateId, pathData });
                              onPathClick(templateId);
                            }}
                          />
                        );
                      })}
                    </g>
                  );
                })}
              </svg>

              {/* Tooltip detail for desktop - same as ImageSlider */}
            </div>
          </TransformComponent>
        </TransformWrapper>
      </div>
      {hoveredData.isOpen && (
        <HoveredTooltip
          position={hoveredData.position}
          data={hoveredData.data}
        />
      )}
    </>
  );
};

const HoveredTooltip = ({ position, data }) => {
  if (!position) return null;

  console.log('HoveredTooltip data:', { position, data });

  const { type, usageArea, wallArea } = data;
  const { label = '', wc, mini } = APARTMENT_ADAPTER[type];
  const isYOverflowing = position.y + 300 > window.innerHeight;
  const isXOverflowing = position.x + 300 > window.innerWidth;
  const positionStyle = {
    left: isXOverflowing ? position.x - 320 : position.x,
    top: isYOverflowing ? position.y - 175 : position.y,
  };

  return (
    <div className="tooltip-desktop" style={positionStyle}>
      <div className="image">
        <img src={mini} alt="Căn hộ" />
      </div>
      <div className="tooltip-body">
        <p className="title">{label}</p>
        <ul className="list">
          <li className="list-item">
            <CheckCircle />
            <span className="text">WC</span>
            <span>{wc}</span>
          </li>
          <li className="list-item">
            <CheckCircle />
            <span className="text">DT thông thuỷ</span>
            <span>{usageArea}m2</span>
          </li>
          <li className="list-item">
            <CheckCircle />
            <span className="text">DT tim tường</span>
            <span>{wallArea}m2</span>
          </li>
        </ul>
      </div>
      <button className="more-btn">Tìm hiểu thêm</button>
    </div>
  );
};
